// Add your custom JS here.

// Reveal Text
gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray(".revealUp").forEach(function (elem) {
    ScrollTrigger.create({
        trigger: elem,
        start: "top 80%",
        end: "bottom 20%",
        //markers: true,
        once: true,
        onEnter: function () {
            gsap.fromTo(
                elem,
                { y: 100, autoAlpha: 0 },
                {
                    duration: 1.25,
                    y: 0,
                    autoAlpha: 1,
                    ease: "back",
                    overwrite: "auto"
                }
            );
        },
    });
});

// Floating Action Button Logic
const fab = document.querySelector('.btn-floating');

if (fab) {
    gsap.to(fab, {
        scrollTrigger: {
            trigger: "body",      
            start: "vh top",      
            toggleActions: "play reverse play reverse", 
        },
        duration: 0.8,
        autoAlpha: 1,           
        y: 0,                    
        ease: "back.out(1.7)", 
        overwrite: "auto",
        /* FIX: We force pointerEvents to "auto" the MOMENT the animation starts.
           This ensures the very first tap works even if the fade isn't finished.
        */
        onStart: () => {
            fab.style.pointerEvents = "auto";
        },
        // Safety check: ensure it stays clickable if the user scrolls fast
        onUpdate: (self) => {
            if (self.progress > 0) {
                fab.style.pointerEvents = "auto";
            }
        }
    });
}
